import { Link, graphql, useStaticQuery } from "gatsby";
import StrokeText from "./strokeText";
import React from "react";
import Marquee from "react-fast-marquee";
import { useMenu } from "../state";

/* Ticker Tape
============================================================================= */

const TickerTape = ({ siteTitle }) => {
  const data = useStaticQuery(
    graphql`
			query {
				sanityMenu {
            ticker_tape_text,
            ticker_tape_url
				}
			}
		`
  );

  const { popupOpen, setPopupOpen } = useMenu();
  // Render Ticker Tape Items
  const renderTickertape = () => {
    return (
      <>
        <div
          onClick={() => {
            if (window.location.pathname !== "/") {
              window.location.href = "/";
            }
            setPopupOpen(true);
          }}
        >
          <p className="ticker-tape-text averta">
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
          </p>
        </div>
        <div onClick={() => setPopupOpen(true)}>
          <p className="ticker-tape-text averta">
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
            {renderTickertapeInternal()}
          </p>
        </div>
      </>
    );
  };

  // Render Tickertape Internal
  const renderTickertapeInternal = () => {
    return (
      <div class="inline-block" rel="noopener noreferrer">
        <span>
          {data.sanityMenu.ticker_tape_text.toUpperCase()}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </div>
    );
  };

  return (
    <a
      className="ticker-tape relative z-30"
      href={data.sanityMenu.ticker_tape_url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Marquee speed={80} gradient={false} pauseOnHover>
        {renderTickertape()}
      </Marquee>
    </a>
  );
};

/* Export
============================================================================= */

export default TickerTape;
